import Tr from 'translations/Translations';

export const SignatureType = {
    QUALIFIED: "QUALIFIED",
    PERSONAL_ID: "PERSONAL_ID",
    E_PUAP: "E_PUAP",
    UNKNOWN: "UNKNOWN"
}
const _TR_PREFIX = 'signature_type_';

export const SignatureTypeLabel = (priceType) => (Tr(_TR_PREFIX + priceType.toLowerCase()));
